export default {
  namespaced: true,
  state: {
    ort: '',
    strasse: '',
    plz: '',
    land: '',
    handelsregisternummer: '',
    hausnummer: '',
    firmenname: '',
    datenuebermittlerpseudonym: '',
    accountpseudonym: ''
  },
  getters: {

    ort(state) {
      return state.ort
    },
    strasse(state) {
      return state.strasse
    },
    plz(state) {
      return state.plz
    },
    land(state) {
      return state.land
    },
    handelsregisternummer(state) {
      return state.handelsregisternummer
    },
    hausnummer(state) {
      return state.hausnummer
    },
    firmenname(state) {
      return state.firmenname
    },
    datenuebermittlerpseudonym(state) {
      return state.datenuebermittlerpseudonym
    },
    accountpseudonym(state) {
      return state.accountpseudonym
    }
  },

  mutations: {
    ort(state, ort) {
      state.ort = ort
    },
    strasse(state, strasse) {
      state.strasse = strasse
    },
    plz(state, plz) {
      state.plz = plz
    },
    land(state, land) {
      state.land = land
    },
    handelsregisternummer(state, handelsregisternummer) {
      state.handelsregisternummer = handelsregisternummer
    },
    hausnummer(state, hausnummer) {
      state.hausnummer = hausnummer
    },
    firmenname(state, firmenname) {
      state.firmenname = firmenname
    },
    datenuebermittlerpseudonym(state, datenuebermittlerpseudonym) {
      state.datenuebermittlerpseudonym = datenuebermittlerpseudonym
    },
    accountpseudonym(state, accountpseudonym) {
      state.accountpseudonym = accountpseudonym
    },
    reset(state) {
      state.ort = ''
      state.strasse = ''
      state.plz = ''
      state.land = ''
      state.handelsregisternummer = ''
      state.hausnummer = ''
      state.firmenname = ''
      state.datenuebermittlerpseudonym = ''
      state.accountpseudonym = ''
    }
  },
  actions: {}
}
